<template>
  <div id="root">
    <v-card class="search-map" flat>
      <v-toolbar dense floating>
        <gmap-autocomplete @place_changed="searchAddress($event)" id="pac-input" placeholder="Pesquisar"/>
        <v-btn icon>
          <i class="fas fa-search"></i>
        </v-btn>
      </v-toolbar>
    </v-card>
    <gmap-map :options="{mapTypeId:'roadmap',mapTypeControl:false}" :center="center" :zoom="17" style="width: 100%; height: 600px">
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
      </gmap-info-window>
      <gmap-cluster :minimumClusterSize="5">
        <gmap-marker :key="i" v-for="(m,i) in markers" :position="m.position" :clickable="true" @click="toggleInfoWindow(m,i)"
                     :icon="{
                        url: m.url,
                    }"
                     :label="{
                        align:'center',
                        text: m.label,
                        color: 'white',
                        fontSize: '13px',
                        fontWeight: 'bold'
                    }">
        </gmap-marker>
      </gmap-cluster>
    </gmap-map>
  </div>
</template>

<script>
import Vue from 'vue';
import {gmapApi} from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

Vue.use(require('vue2-google-maps'), {
  load: {
    key: process.env.VUE_APP_KEY_GOOGLE_MAPS,
    libraries: 'places,drawing,visualization',
    installComponents: false,
  },
});
export default {
  name: "VueMap",
  components: {GmapCluster},
  props: [
    'markerList',
    "centerOv",
    "draggableOv",
    "searchOv",
    "plates"
  ],
  computed: {
    google: gmapApi
  },
  data: function () {
    return {
      currentLocation: {
        lat: 0,
        lng: 0
      },
      markers: [],
      center: {
        lat: -25.0994,
        lng: -50.1583
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
    }
  },
  watch: {
    markerList: {
      immediate: true,
      deep: true,
      handler() {
        this.markers = this.markerList;
      }
    },
    centerOv: {
      immediate: true,
      deep: true,
      handler() {
        this.center = this.centerOv;
      }
    }
  },
  mounted: function () {
    this.geolocation();
  },
  methods: {
    searchAddress: function (place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      if (this.draggableOv === true) {
        this.markers = [{
          position: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        }];
      }
      this.$emit('searchResult', this.center);
    },
    updateMarker: function (event) {
      this.$emit('update-marker', {lat: event.latLng.lat(), lng: event.latLng.lng()});
    },
    geolocation: function () {
      navigator.geolocation.watchPosition((position) => {
        if (this.checkExistMarker() === null) {
          this.center.lat = position.coords.latitude;
          this.center.lng = position.coords.longitude;
        } else {
          this.markers.splice((this.checkExistMarker()), 1);
        }
        this.markers.push(
            {
              url: require('@/assets/imgs/current-location.png'),
              infoText: '<strong>Você esta aqui!</strong>',
              scaledSize: {width: 1, height: 1},
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
            }
        )
      }, () => {
      }, {enableHighAccuracy: true,});
    },
    checkExistMarker: function () {
      var marker_exist = null;
      this.markers.forEach(function (item, index) {
        if (item.infoText === '<strong>Você esta aqui!</strong>') {
          marker_exist = index;
        }
      });
      return marker_exist;
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infoText;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

      }
    }
  }
}
</script>

<style scoped>
.search-map {
  position: absolute;
  margin: 10px 0 0 10px;
  z-index: 2;
}

.v-toolbar__content, .search-map, #pac-input {
  width: 400px;
}

@media only screen and (max-width: 500px) {
  .v-toolbar__content, .search-map, #pac-input {
    width: 80px;
  }
}

</style>
